function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n",
        ";\n\nbody {\n  background-color: ",
        ";\n  color: ",
        ";\n}\n\n#root {\n  min-height: 100%;\n}\n\nsvg {\n  vertical-align: middle;\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { createGlobalStyle } from "styled-components";
import nanoreset from "./nanoreset";
var GlobalStyle = createGlobalStyle(_templateObject(), nanoreset, function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, function(param) {
    var theme = param.theme;
    return theme.palette.primaryText;
});
export default GlobalStyle;
